export default __webpack_public_path__ + "static/media/store-10.05b79835.png";